
























import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { OverviewLayoutITF, FixedFilter } from '@/interfaces';

@Component
export default class DeviceTypesOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public fixedFilter: FixedFilter = {};

  public filterChanged() {
    ((this.$refs.overview as unknown) as OverviewLayoutITF).tableUpdateData();
    // Update store
    this.setDeviceGroupID(this.fixedFilter.devicegroup_id);
  }

  // Lifecycle Functions
  public mounted() {
    this.fixedFilter.devicegroup_id = this.getDeviceGroupID();
  }
}
